<template>

  <loading-data-page-container
    :loading="!isInitialized && !loadingError"
    :loading-error="loadingError"
    :loading-error-message="loadingErrorMessage"
    :hint="loadingErrorHint"
    max-width>

    <template v-if="isInitialized && !loadingError">


    <product-info-block :sections="VertriebVerkaufshilfen.sections"
                          title="Verkaufshilfen" />

    </template>

  </loading-data-page-container>

</template>


<script>

import ProductInfoBlock from "@/components/productInfo/ProductInfoBlock";
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";

export default {
  name: "VerkaufshilfenPage",
  components: { ProductInfoBlock, LoadingDataPageContainer },
  mixins: [contentLoadingMixin(["VertriebVerkaufshilfen"])]
};
</script>

